import React from 'react';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentSave from 'material-ui/svg-icons/content/save';
import ContentClear from 'material-ui/svg-icons/content/clear';
import ChipInput from 'material-ui-chip-input';
import { CardText } from 'material-ui/Card';
import {
    GridList,
    GridTile,
} from 'material-ui/GridList';

import PublicMaster from '../master/Public';
import {
    Utils,
    pessoaService,
    nivelAcessoService,
    paginaService,
} from '../../services';

class Pessoa extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editing: false,
            isPosting: false,
            nome: '',
            email: '',
            emailErrorText: '',
            cpf: '',
            cpfErrorText: '',
            codigoEDPESSOAS: 0,
            niveisAcessoSelecionados: [],
            pessoaLogosSelecionada: '',
            dsPessoasLogos: [],
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        const form = await pessoaService.pessoaForm();
        this.csrfToken = form.token;
        this.formId = form.formId;

        const codigo = this.props.match.params.codigo;
        if (codigo) {
            try {
                const pessoa = await pessoaService.getPessoa(codigo);
                const niveisAcesso = await pessoaService.getPessoaNiveis(codigo);
                this.setState({
                    editing: true,
                    nome: pessoa.NOME,
                    email: pessoa.EMAIL,
                    cpf: pessoa.CPF || '',
                    codigoEDPESSOAS: pessoa.CODIGOEDPESSOAS || 0,
                    niveisAcessoSelecionados: niveisAcesso,
                });
            } catch (error) {
                Utils.showToast(error.message);
            }
        }
        Utils.showLoading(false);
    }

    async onGetNiveisAcesso(value) {
        const niveisAcesso = await paginaService.getNiveisAcesso(value);
        this.setState({ dsNiveisAcesso: niveisAcesso });
    }

    //#region Validadores.
    camposSaoValidos() {
        const {
            nome,
            email,
        } = this.state;

        let camposValidos = true;
        camposValidos = this.validarEmail(email);
        camposValidos = !!nome;
        return camposValidos;
    }

    validarCPF(value) {
        if (!value) {
            return true;
        }
        if (!Utils.isCPFValido(value)) {
            this.setState({ cpfErrorText: 'CPF inválido', cpf: value });
            return false;
        }
        else {
            this.setState({ cpfErrorText: '', cpf: value });
            return true;
        }
    }

    async validarEmail(value) {
        let codigo = this.props.match.params.codigo;
        if (!codigo) {
            codigo = 0;
        }
        if (!Utils.isEmailValido(value)) {
            this.setState({ emailErrorText: 'E-mail inválido' });
            return false;
        } else {
            if (await pessoaService.emailJaExiste(value, codigo)) {
                this.setState({ emailErrorText: 'E-mail já cadastrado' });
                return false;
            } else {
                this.setState({ emailErrorText: '' });
                return true;
            }
        }
    }
    //#endregion

    async onSave(event) {
        event.preventDefault();
        const {
            editing,
            isPosting,
            nome,
            email,
            cpf,
            niveisAcessoSelecionados,
            codigoEDPESSOAS,
        } = this.state;

        if (isPosting) {
            return;
        }
        if (!this.camposSaoValidos()) {
            Utils.showToast('Há campos inválidos.');
            return;
        }
        this.setState({ isPosting: true });
        try {
            let response;
            if (editing) {
                response = await pessoaService.update({
                    codigo: this.props.match.params.codigo,
                    nome,
                    email,
                    cpf,
                    niveisAcessoSelecionados,
                    codigoEDPESSOAS,
                    _csrf: this.csrfToken,
                });
            } else {
                response = await pessoaService.save({
                    nome,
                    email,
                    cpf,
                    niveisAcessoSelecionados,
                    codigoEDPESSOAS,
                    _csrf: this.csrfToken,
                    formId: this.formId,
                });
            }
            Utils.showToast(response.message);
            this.props.history.push('/pessoas');
        } catch (e) {
            this.setState({ isPosting: false });
            Utils.showToast(e.message);
        }
    }

    render() {
        const {
            isPosting,
            nome,
            email,
            emailErrorText,
            cpf,
            cpfErrorText,
            codigoEDPESSOAS,
            dsNiveisAcesso,
            niveisAcessoSelecionados,
        } = this.state;

        const isTodosCamposValidos = !!nome && !emailErrorText && !cpfErrorText;

        return (
            <PublicMaster title='Nova pessoa'>
                <div style={styles.content}>
                    <form onSubmit={e => this.onSave(e)}>
                        <TextField
                            floatingLabelText='Nome'
                            required
                            fullWidth={true}
                            errorText={nome ? '' : 'Campo obrigatório'}
                            onChange={e => this.setState({ nome: e.target.value })}
                            value={nome}
                        />
                        <GridList cellHeight="auto">
                            <GridTile>
                                <NumberFormat
                                    format='###.###.###-##'
                                    customInput={TextField}
                                    value={cpf}
                                    errorText={cpfErrorText}
                                    floatingLabelText='CPF'
                                    onChange={e => this.validarCPF(e.target.value)}
                                />
                            </GridTile>
                            <GridTile>
                                <TextField
                                    floatingLabelText='Código Logos'
                                    onChange={e => this.setState({ codigoEDPESSOAS: +e.target.value })}
                                    value={codigoEDPESSOAS}
                                />
                            </GridTile>
                        </GridList>
                        <TextField
                            floatingLabelText='E-mail'
                            required
                            fullWidth={true}
                            errorText={emailErrorText}
                            onChange={e => this.setState({email: e.target.value})}
                            onBlur={e => this.validarEmail(e.target.value)}
                            value={email}
                        />
                        <CardText style={{ padding: 0 }}>
                            <ChipInput
                                value={niveisAcessoSelecionados}
                                newChipKeyCodes={[]}
                                fullWidth={true}
                                floatingLabelText='Níveis de acesso'
                                onUpdateInput={value => this.onGetNiveisAcesso(value)}
                                dataSourceConfig={{ text: 'NOME', value: 'CODIGO' }}
                                dataSource={dsNiveisAcesso}
                                onRequestDelete={value => this.setState({ niveisAcessoSelecionados: niveisAcessoSelecionados.filter(x => x.CODIGO !== value) })}
                                onRequestAdd={nivelAcesso => this.setState({ niveisAcessoSelecionados: niveisAcessoSelecionados.concat(nivelAcesso) })}
                            />
                        </CardText>
                        <div className='fab-buttons'>
                            <FloatingActionButton type='submit' disabled={isPosting || !isTodosCamposValidos} style={{ marginRight: 8 }} >
                                <ContentSave />
                            </FloatingActionButton>
                            <FloatingActionButton onClick={() => this.props.history.push('/pessoas')} backgroundColor='rgb(100, 100, 100)'>
                                <ContentClear />
                            </FloatingActionButton>
                        </div>
                    </form>
                </div>
            </PublicMaster>
        );
    }
}

const styles = {
    content: {
        padding: 16,
    },
};

export default Pessoa;
